import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { showDistance } from 'frontend-utils';

export default class BenchmarkInsightCompetitorsCompetitor extends Model {
  [Type] = 'benchmark-insight/competitors/competitor' as const;

  @attr('string') declare hotelClass: string;
  @attr('number') declare latitude: number;
  @attr('number') declare longitude: number;
  @attr('string') declare name: string;
  @attr('number') declare roomCount: number;
  @attr('number') declare stars: number;

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get competitorName() {
    if (this.hotelAndMarketService.isDemoModeActive) {
      return this.intl.t('general.competitor');
    }

    return this.name;
  }

  get distance(): string {
    const { hotel } = this.hotelAndMarketService;

    if (!hotel?.hotelinfo) {
      return '';
    }

    const { latitude, longitude } = this;

    return showDistance(hotel.hotelinfo, {
      latitude,
      longitude,
    });
  }
}
